'use client';

import { AppContextProvider } from '@/components/app-context';
import { LanguageProvider } from '@/components/language-provider';
import { ThemeProvider } from '@/components/theme-provider';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AppContextProvider>{children}</AppContextProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}
